// Similar to PricingModeEnum provided in types.ts provided by back end; however we need a value to represent the Default case as well on UI

export const PricingMode = {
  ImpliedVolatility: 'ImpliedVolatility',
  UnderlyingQuoteCurrency: 'UnderlyingQuoteCurrency',
  BPS: 'BPS',
  Default: 'Default',
} as const;
export type PricingMode = (typeof PricingMode)[keyof typeof PricingMode];
